<template>
  <div class="race-event-summary">
    <h1>Event Summary</h1>
    <ul>
      <li v-for="race in races" :class="classNameForRace(race)">
        <span class="race-name">{{ race.name }}</span>
        <span class="race-start">{{ $fmt.date(race.startTime, this.raceEvent?.timezoneOffset) }}</span>
        <span class="race-dist">{{ $fmt.distance(race.distance, 0) }} </span>
      </li>
    </ul>
  </div>
</template>

<style lang="scss">
.race-event-summary {
  color: var(--text-color);
  width: min-content;

  h1 {
    font-size: 20px;
    margin-left: 1rem;
    padding: 0;
  }
  
  ul {
    margin: 4px 4px 0;
    padding: 0;
    list-style: none;
    min-width: 250px;
  }
  
  li {
    display: flex;
    padding: 0.5rem;
    align-items: center;
    border-radius: var(--br-sharp);
    &:nth-child(2n+1) { background: var(--alternate-row-hbgcolor); }
    
    span       { flex: 1; }
    .race-name { 
      width: max-content;
      font-weight: bold;
    }
    .race-start {
      width: max-content;
      white-space: nowrap;
      margin: 0 1rem;
      text-align: right;
    }
    .race-dist {
      text-align: right;
    }
  }
  
  
}
</style>

<script>
  export default {
    props: {
      raceEvent: {
        type: Object,
        required: true,
      }
    },
    
    computed: {
      races() {
        let allRaces = this.raceEvent?.races ?? [];
        let races = [];
        for (let i=0; i<allRaces.length; i++)
          if (allRaces[i].distance > 0) races.push(allRaces[i])

        return races.sort((a,b) => {
          a = a && a.startTime || new Date('2100-01-01'); // return a distant future date to influence sorting of unset values.
          b = b && b.startTime || new Date('2100-01-01');
          return a - b;
        });
      },
      
    },
    
    methods: {
      classNameForRace(race) {
        return 'race'; //@TODO: set class name based on color, maybe inline SVG color icon, etc.
      },
      
    }
    
  }
</script>
